"use client";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@pex/ui-web";

const TESTIMONIALS = [
  {
    quote:
      "\u201CLearning about the science of my addiction, and processing areas that I haven\u2019t wanted to explore or dig through.\u201D",
    name: "Edward Naidoo",
  },
  {
    quote:
      "\u201CMuch character development, understanding maladaptive or dysfunctional behaviour patterns and conflicts. Found a new meaning of true surrender, dying to my ways or methods. There is nothing mundane about recovery.\u201D",
    name: "Darius Petersen",
  },
  {
    quote:
      "\u201CI found the research from professionals and sources very helpful. The questions were also worded in a way that made me think deeper than the surface level.\u201D",
    name: "Sibusiso Dlamini",
  },
  {
    quote:
      "\u201CIdentifying the different types of maladaptive mechanisms and types of denial that exists. And the survey that gives you a general idea of the degree of your addiction.\u201D",
    name: "Kyle Arendse",
  },
  {
    quote:
      "\u201CThe questions are structured for personal realisations that are able to cut through denial.\u201D",
    name: "William Owen",
  },
  {
    quote:
      "\u201CThe content was just wonderfully written. Super consistent, always relevant and helpful \u2014 all the footnotes with research were incredibly helpful.\u201D",
    name: "Ethan Roberts",
  },
] as const;

const STAR_KEYS = ["1", "2", "3", "4", "5"] as const;

function StarRating() {
  return (
    <div aria-label="5 out of 5 stars" className="flex gap-0.5" role="img">
      {STAR_KEYS.map((n) => (
        <svg
          aria-hidden="true"
          className="h-5 w-5 fill-amber-400 text-amber-400"
          key={n}
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      ))}
    </div>
  );
}

export function VantageTestimonialsCarousel() {
  return (
    <div className="relative">
      {/* Edge fade overlays — pointer-events-none so cards/buttons remain interactive */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute top-0 bottom-16 left-0 z-10 w-32"
        style={{
          background:
            "linear-gradient(to right, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.6) 40%, rgba(255,255,255,0) 100%)",
        }}
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute top-0 right-0 bottom-16 z-10 w-32"
        style={{
          background:
            "linear-gradient(to left, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.6) 40%, rgba(255,255,255,0) 100%)",
        }}
      />
      <Carousel className="w-full" opts={{ loop: true }}>
        <CarouselContent className="-ml-4">
          {TESTIMONIALS.map((t) => (
            <CarouselItem className="pl-4 md:basis-1/2" key={t.name}>
              <div className="flex h-full flex-col gap-4 rounded-2xl border bg-card p-6 shadow-sm">
                <StarRating />
                <p className="body-base flex-1">{t.quote}</p>
                <span className="font-semibold text-sm">{t.name}</span>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <div className="mt-6 flex items-center gap-2 px-1">
          <CarouselPrevious className="static translate-y-0" />
          <CarouselNext className="static translate-y-0" />
        </div>
      </Carousel>
    </div>
  );
}
